/* PAX buy box — bundle properties.
 *
 * THE THING THAT IS EASY TO MISS: the Super Subscriptions pack discount is applied by a
 * Shopify Function that keys on LINE ITEM PROPERTIES, not on quantity. An app-driven cart
 * carries:
 *     _bundle_block_id       6a689d17d25b222520999ca5
 *     _bundle_block_name     "3 Tins"
 *     _bundle_block_quantity "3"
 * Without them the Function ignores the cart and every pack is charged at full price —
 * 3 tins came out $38.70 instead of $32.90, 6 tins $77.40 instead of $59.90.
 *
 * The values are read from the app's own (hidden) block so they can never drift from the
 * app's configuration. If the block is missing we return null and the buy box adds without
 * properties, which is full price — wrong but not broken. */
window.paxBundleProps = function (qty) {
  var root = document.querySelector('[data-bundle-block-id]');
  if (!root) return null;
  var id = root.dataset.bundleBlockId;
  if (!id) return null;
  var name = null;
  var tiers = root.querySelectorAll('.sss-bundle-block__tier');
  for (var i = 0; i < tiers.length; i++) {
    if (parseInt(tiers[i].dataset.tierQuantity, 10) === qty) { name = tiers[i].dataset.tierTitle; break; }
  }
  if (name === null) return null;
  return {
    _bundle_block_id: id,
    _bundle_block_name: name,
    _bundle_block_quantity: String(qty)
  };
};
